export default __webpack_public_path__ + "static/media/Marilla.27215700.png";